import script from "./FormDescription.vue?vue&type=script&setup=true&lang=js"
export * from "./FormDescription.vue?vue&type=script&setup=true&lang=js"

import "./FormDescription.vue?vue&type=style&index=0&id=79b7dfc5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79b7dfc5"]])

export default __exports__